import { TRANSACTIONS_HISTORY } from '../../constants/actions'

const getTransactions = (offset, loading, loadingTx) => ({
  type: TRANSACTIONS_HISTORY.ON_GET_TRANSACTIONS,
  payload: { offset, loading, loadingTx }
})

export { getTransactions }
